import { MenuHeader } from '../../menu/menu-mobile/menu-header/menu-header';
import { StyledMenuMobile } from '../../menu/menu-mobile/menu-mobile.styles';
import { createSignal } from 'solid-js';
import { LoginForm } from '../../login-form/login-form';
import { TabHandler } from '../../menu/menu-desktop/tab-handling';

type LoginMenuMobileProps = {
    handleCloseMenuClick: () => void;
    handleSignOutClick: () => void;
};

export const LoginMenuMobile = (props: LoginMenuMobileProps) => {
    // Accessibility/keyboard-controls related
    const [ firstTabbableElement, setFirstTabbableElement ] = createSignal<HTMLElement | undefined>();
    const [ lastTabbableElement, setLastTabbableElement ] = createSignal<HTMLElement | undefined>();

    return (
        <TabHandler
            refs={{
                firstTabbableElement,
                lastTabbableElement,
            }}
        >
            <StyledMenuMobile>

                <MenuHeader handleCloseMenuClick={props.handleCloseMenuClick} />

                <LoginForm
                    firstElement={(el: HTMLElement) => {
                        setFirstTabbableElement(el);
                    }}
                    lastElement={(el: HTMLElement) => {
                        setLastTabbableElement(el);
                    }}
                /> 
            </StyledMenuMobile>
        </TabHandler>
    );
};
